var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('b-card-actions', {
    attrs: {
      "action-collapse": "",
      "title": "Daftar Ajuan Barang"
    }
  }, [_c('b-row', {
    staticClass: "align-items-end mb-1"
  }, [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "2",
      "sm": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Per halaman",
      "label-for": "perPageSelect"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "perPageSelect",
      "size": "sm",
      "options": _vm.pageOptions
    },
    model: {
      value: _vm.perPage,
      callback: function callback($$v) {
        _vm.perPage = $$v;
      },
      expression: "perPage"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Status Ajuan",
      "label-for": "statusSelect"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "statusSelect",
      "size": "sm",
      "options": _vm.statusOptions
    },
    model: {
      value: _vm.selectedStatus,
      callback: function callback($$v) {
        _vm.selectedStatus = $$v;
      },
      expression: "selectedStatus"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "4",
      "sm": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Cari",
      "label-for": "filterInput"
    }
  }, [_c('b-input-group', {
    attrs: {
      "size": "sm"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "filterInput",
      "type": "search",
      "placeholder": "Cari no ajuan / sales / keterangan..."
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.applySearch($event);
      }
    },
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.clearSearch
    }
  }, [_vm._v(" Clear ")])], 1)], 1)], 1)], 1), _c('b-col', {
    staticClass: "my-1 d-flex justify-content-md-end",
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_vm.allowCreate() && _vm.isSales && _vm.myGudang ? _c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(113, 102, 240, 0.15)',
      expression: "'rgba(113, 102, 240, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "PlusIcon"
    }
  }), _vm._v(" Ajuan Barang ")], 1) : _vm._e()], 1)], 1), _vm.allowCreate() || _vm.allowUpdate() ? _c('b-modal', {
    attrs: {
      "id": "modal-ajuan-barang",
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      "centered": "",
      "title": "Form Ajuan Barang",
      "hide-footer": ""
    },
    model: {
      value: _vm.showModal,
      callback: function callback($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [_c('validation-observer', {
    ref: "formRequestbarang"
  }, [_c('div', {
    staticClass: "d-flex mb-1"
  }, [_c('feather-icon', {
    attrs: {
      "icon": "PackageIcon",
      "size": "19"
    }
  }), _c('h6', {
    staticClass: "ml-50 mb-0"
  }, [_vm._v("Data Ajuan Barang")])], 1), _c('b-form', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tanggal Ajuan",
      "label-for": "v-tanggal_waktu"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "tanggal_waktu",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-tanggal_waktu",
            "type": "date",
            "state": errors.length > 0 ? false : null
          },
          model: {
            value: _vm.form.tanggal_waktu,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "tanggal_waktu", $$v);
            },
            expression: "form.tanggal_waktu"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 3658761348)
  })], 1)], 1), _vm.isSPV ? _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Pilih Sales",
      "label-for": "v-sales_id"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "sales_id",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var errors = _ref2.errors;
        return [_c('v-select', {
          attrs: {
            "options": _vm.sales_id,
            "label": "text"
          },
          model: {
            value: _vm.form.sales_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "sales_id", $$v);
            },
            expression: "form.sales_id"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 3642507825)
  })], 1), _vm.userData && _vm.userData.level && _vm.userData.level.id == 7 ? _c('b-form-group', {
    attrs: {
      "label": "Pilih Sales",
      "label-for": "v-sales_id_disabled"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "sales_id_disabled",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var errors = _ref3.errors;
        return [_c('b-form-select', {
          attrs: {
            "id": "v-sales_id_disabled",
            "state": errors.length > 0 ? false : null,
            "options": _vm.sales_id,
            "name": "sales_id",
            "disabled": ""
          },
          model: {
            value: _vm.form.sales_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "sales_id", $$v);
            },
            expression: "form.sales_id"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 2699494974)
  })], 1) : _vm._e()], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Pilih Rute",
      "label-for": "v-rute"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "rute",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var errors = _ref4.errors;
        return [_c('v-select', {
          attrs: {
            "label": "text",
            "options": _vm.routes,
            "multiple": ""
          },
          model: {
            value: _vm.form.rutes,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "rutes", $$v);
            },
            expression: "form.rutes"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 4249390264)
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Keterangan",
      "label-for": "v-keterangan"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "v-keterangan",
      "placeholder": "Isi Keterangan"
    },
    model: {
      value: _vm.form.keterangan,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "keterangan", $$v);
      },
      expression: "form.keterangan"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center mt-2"
  }, [_c('b-button', {
    staticClass: "mr-1",
    attrs: {
      "size": "sm",
      "variant": "outline-secondary",
      "disabled": _vm.saving
    },
    on: {
      "click": function click($event) {
        _vm.showModal = false;
      }
    }
  }, [_vm._v(" Batal ")]), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "primary",
      "disabled": _vm.saving
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.submit($event);
      }
    }
  }, [_vm.saving ? _c('b-spinner', {
    staticClass: "mr-50",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.saving ? "Menyimpan..." : _vm.id ? "Ubah" : "Simpan") + " ")], 1)], 1)], 1) : _vm._e(), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [!_vm.loading && !_vm.items.length ? _c('div', {
    staticClass: "text-center text-muted py-4 border rounded"
  }, [_vm._v(" Belum ada data ajuan barang "), _vm.filter ? _c('span', [_vm._v(" untuk pencarian “" + _vm._s(_vm.filter) + "”")]) : _vm._e(), _vm._v(". ")]) : _c('b-table', {
    attrs: {
      "striped": "",
      "small": "",
      "hover": "",
      "responsive": "",
      "items": _vm.items,
      "fields": _vm.fields,
      "show-empty": "",
      "empty-text": "Tidak ada data"
    },
    scopedSlots: _vm._u([{
      key: "cell(i)",
      fn: function fn(_ref5) {
        var index = _ref5.index;
        return [_vm._v(" " + _vm._s((_vm.currentPage - 1) * _vm.perPage + index + 1) + " ")];
      }
    }, {
      key: "cell(info)",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c('a', {
          staticClass: "ajuan-info-link d-block text-body",
          attrs: {
            "href": "#"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.goDetail(item);
            }
          }
        }, [_c('div', {
          staticClass: "ajuan-info-no"
        }, [_vm._v(_vm._s(item.no || "-"))]), _c('strong', {
          staticClass: "d-block ajuan-info-date"
        }, [_vm._v(" " + _vm._s(_vm.humanDate(item.tanggal_waktu)) + " ")]), _c('small', {
          staticClass: "text-muted ajuan-info-meta"
        }, [_vm._v(" " + _vm._s(item.total_barang != null ? item.total_barang : 0) + " barang ")])])];
      }
    }, {
      key: "cell(diajukan_oleh)",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_vm._v(" " + _vm._s(_vm.getSalesLabel(item)) + " ")];
      }
    }, {
      key: "cell(status)",
      fn: function fn(_ref8) {
        var _item$status, _item$status_data, _item$status2, _item$status_data2;

        var item = _ref8.item;
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.setStatus((_item$status = item.status) !== null && _item$status !== void 0 ? _item$status : (_item$status_data = item.status_data) === null || _item$status_data === void 0 ? void 0 : _item$status_data.data_status).color
          }
        }, [_vm._v(" " + _vm._s(_vm.setStatus((_item$status2 = item.status) !== null && _item$status2 !== void 0 ? _item$status2 : (_item$status_data2 = item.status_data) === null || _item$status_data2 === void 0 ? void 0 : _item$status_data2.data_status).text) + " ")])];
      }
    }, {
      key: "cell(keterangan)",
      fn: function fn(_ref9) {
        var item = _ref9.item;
        return [_vm._v(" " + _vm._s(item.keterangan || "-") + " ")];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(row) {
        return [_vm.allowUpdate() ? _c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            value: _vm.isAjuanSelesai(row.item) ? 'Ajuan selesai tidak dapat diubah' : 'Ubah',
            expression: "isAjuanSelesai(row.item) ? 'Ajuan selesai tidak dapat diubah' : 'Ubah'",
            modifiers: {
              "hover": true,
              "right": true
            }
          }],
          staticClass: "mr-50",
          attrs: {
            "size": "sm",
            "variant": "outline-info",
            "disabled": _vm.isAjuanSelesai(row.item)
          },
          on: {
            "click": function click($event) {
              return _vm.edit(row.item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "EditIcon"
          }
        })], 1) : _vm._e(), _c('b-dropdown', {
          attrs: {
            "size": "sm",
            "variant": "outline-secondary",
            "right": "",
            "no-caret": "",
            "boundary": "viewport"
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "MoreVerticalIcon"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, [_c('b-dropdown-item-button', {
          on: {
            "click": function click($event) {
              return _vm.$router.push("/ajuanbarang/detail/".concat(row.item.id));
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "EyeIcon"
          }
        }), _vm._v(" Detail ")], 1), _vm.isAdminGudang && !_vm.isSales && row.item.status == 4 ? _c('b-dropdown-item-button', {
          on: {
            "click": function click($event) {
              return _vm.downloadAttachment(row.item.id);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "FileTextIcon"
          }
        }), _vm._v(" Surat Jalan ")], 1) : _vm._e(), _vm.allowDelete() ? _c('b-dropdown-item-button', {
          attrs: {
            "disabled": _vm.isAjuanSelesai(row.item)
          },
          on: {
            "click": function click($event) {
              return _vm.remove(row.item);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "TrashIcon"
          }
        }), _vm._v(" Hapus ")], 1) : _vm._e()], 1)];
      }
    }])
  })], 1), _c('b-col', {
    staticClass: "d-flex justify-content-between align-items-center mt-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Total " + _vm._s(_vm.totalRows) + " data")]), _c('b-pagination', {
    staticClass: "my-0",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "right",
      "size": "sm"
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }